module.exports = __webpack_public_path__ + "img/home_1.8a2ce152.jpg";